import apiClient from './apiClient/agile'
export async function getCityListByProvinceId(id: string) {
  const res = await apiClient.get('district/getchildren', {
    params: { id },
  });
  return res;
}

export async function getMemberManagerList(params: { companyId?: string , searchName?:string, managerIdList?:string[]}) {
  const res = await apiClient({
    url: '/member/search',
    method: 'post',
    params: {},
    data: { ...params }
  })
  return res.data as any as {companyId:string, nickName:string, managerId:string, id:string, personId:string,mobile?:string}[];
}